import script from "./PingLunHuiKuiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PingLunHuiKuiPage.vue?vue&type=script&setup=true&lang=js"

import "./PingLunHuiKuiPage.vue?vue&type=style&index=0&id=dd902ac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd902ac6"]])

export default __exports__